/**
 * Parses a user-typed decimal. Accepts a German decimal comma ("2,5") as well
 * as a dot; returns NaN for empty or non-numeric input so callers can validate.
 * why: with a comma present, dots are German thousands separators ("1.000,50")
 * and must be dropped — otherwise "1.000" would silently become 1.
 */
export const parseDecimal = (value: string): number => {
  const raw = value.trim();
  if (raw === '') return Number.NaN;
  const normalized = raw.includes(',') ? raw.replace(/\./g, '').replace(',', '.') : raw;
  return Number(normalized);
};

/** Formats a stored number the way the user types it (German decimal comma). */
export const toInputDecimal = (value?: number | null): string =>
  value == null ? '' : String(value).replace('.', ',');
